import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export async function exportToPdf(elementId: string, title: string): Promise<void> {
  const element = document.getElementById(elementId);
  if (!element) return;

  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    backgroundColor: '#ffffff',
  });

  const imgData = canvas.toDataURL('image/png');
  const pdf = new jsPDF('l', 'mm', 'a4');

  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  // Header
  pdf.setFillColor(29, 130, 150); // #1D8296
  pdf.rect(0, 0, pageWidth, 15, 'F');
  pdf.setTextColor(255, 255, 255);
  pdf.setFontSize(12);
  pdf.text(title, 10, 10);
  pdf.setFontSize(8);
  pdf.text(new Date().toLocaleDateString('de-DE') + ' ' + new Date().toLocaleTimeString('de-DE'), pageWidth - 50, 10);

  // Content
  const imgWidth = pageWidth - 20;
  const imgHeight = (canvas.height * imgWidth) / canvas.width;
  let yPos = 20;

  if (imgHeight <= pageHeight - 25) {
    pdf.addImage(imgData, 'PNG', 10, yPos, imgWidth, imgHeight);
  } else {
    // Multi-page
    let remainingHeight = imgHeight;
    let _srcY = 0;
    while (remainingHeight > 0) {
      const pageContentHeight = pageHeight - (yPos + 5);
      const sliceHeight = Math.min(remainingHeight, pageContentHeight);
      pdf.addImage(imgData, 'PNG', 10, yPos, imgWidth, imgHeight, undefined, 'FAST');
      remainingHeight -= sliceHeight;
      _srcY += sliceHeight;
      if (remainingHeight > 0) {
        pdf.addPage();
        yPos = 10;
      }
    }
  }

  pdf.save(`${title.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.pdf`);
}
